import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { kpiAPI, notificationsAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function Dashboard() {
  const { user }    = useAuth();
  const navigate    = useNavigate();
  const [kpi, setKpi]     = useState({});
  const [notifs, setNotifs] = useState([]);

  useEffect(() => {
    kpiAPI.get().then(r => setKpi(r.data)).catch(()=>{});
    notificationsAPI.list().then(r => setNotifs(r.data.slice(0,5))).catch(()=>{});
  }, []);

  const stats = [
    { icon:'💬', label:'رسائل غير مقروءة', val: kpi.unread_messages||0, sub:'جديد', color:'var(--inb)', to:'/chat' },
    { icon:'👥', label:'مجموعات نشطة',     val: kpi.active_groups||0,  sub:'٢٣ عضو', color:'var(--gdl)', to:'/groups' },
    { icon:'📹', label:'اجتماعات الشهر',   val: kpi.meetings_this_month||0, sub:'قادم', color:'var(--okb)', to:'/video' },
    { icon:'📢', label:'تعاميم مرسلة',     val: kpi.sent_circulars||0, sub:'عاجل', color:'var(--wab)', to:'/circulars' },
    { icon:'👤', label:'مستخدمون نشطون',   val: kpi.active_users||0,   sub:`${kpi.online_users||0} متصل`, color:'var(--pub)', to:'/users' },
  ];

  const quickActions = [
    { icon:'💬', label:'رسالة فردية',    to:'/chat' },
    { icon:'👥', label:'جروب جديد',      to:'/groups' },
    { icon:'📹', label:'اجتماع مرئي',    to:'/video' },
    { icon:'📢', label:'تعميم جديد',     to:'/circulars' },
    { icon:'📤', label:'رفع ملف',        to:'/files' },
    { icon:'🖊', label:'قرار إداري',     to:'/decisions' },
  ];

  return (
    <div className="fade-in">
      {/* Stats */}
      <div className="g5">
        {stats.map(s => (
          <div key={s.label} className="stat-card" onClick={() => navigate(s.to)}>
            <div className="stat-icon" style={{background:s.color}}>{s.icon}</div>
            <div>
              <div className="stat-value">{s.val}</div>
              <div className="stat-label">{s.label}</div>
              <div className="stat-extra up">{s.sub}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="g2">
        {/* Left column */}
        <div>
          {/* AI Banner */}
          <div className="ai-banner" style={{marginBottom:12}}>
            <div style={{display:'flex',alignItems:'center',gap:9,marginBottom:10}}>
              <span style={{fontSize:20}}>🤖</span>
              <div>
                <div style={{fontSize:12,fontWeight:800}}>مساعد الذكاء الاصطناعي</div>
                <div style={{fontSize:8.5,opacity:.6}}>متخصص في التواصل الإداري الرياضي</div>
              </div>
              <span style={{background:'var(--gd)',color:'var(--nv)',fontSize:8,fontWeight:800,padding:'2px 7px',borderRadius:8,marginRight:'auto'}}>Claude AI</span>
            </div>
            <div>
              {['✍️ كتابة تعميم','📊 تلخيص اجتماع','🖊 قرار إداري','📈 تحليل بيانات','🔍 بحث ذكي'].map(c => (
                <span key={c} className="ai-chip" onClick={() => navigate('/ai')}>{c}</span>
              ))}
            </div>
          </div>

          {/* Quick Actions */}
          <div className="card">
            <div className="card-header">
              <div className="card-icon" style={{background:'var(--inb)'}}>⚡</div>
              <div className="card-title">إجراءات سريعة</div>
            </div>
            <div className="card-body" style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
              {quickActions.map(a => (
                <div key={a.label} style={{border:'1px solid var(--b1)',borderRadius:9,padding:10,textAlign:'center',cursor:'pointer',transition:'all .14s'}}
                  onClick={() => navigate(a.to)}
                  onMouseOver={e=>e.currentTarget.style.borderColor='var(--nv)'}
                  onMouseOut={e=>e.currentTarget.style.borderColor='var(--b1)'}>
                  <div style={{fontSize:18,marginBottom:4}}>{a.icon}</div>
                  <div style={{fontSize:10,fontWeight:800}}>{a.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right column - Notifications */}
        <div>
          <div className="card">
            <div className="card-header">
              <div className="card-icon" style={{background:'var(--wab)'}}>🔔</div>
              <div className="card-title">التنبيهات الفورية</div>
              <div className="card-sub" style={{marginRight:'auto'}}>{notifs.filter(n=>!n.is_read).length} غير مقروء</div>
            </div>
            <div className="card-body" style={{display:'flex',flexDirection:'column',gap:6}}>
              {notifs.length ? notifs.map(n => (
                <div key={n.id} style={{display:'flex',gap:8,alignItems:'flex-start',padding:7,background:n.is_read?'var(--bg)':'var(--inb)',borderRadius:8,border:'1px solid var(--b1)'}}>
                  <span style={{fontSize:14}}>🔔</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:10,fontWeight:700}}>{n.title}</div>
                    <div style={{fontSize:8,color:'var(--t3)'}}>{new Date(n.created_at).toLocaleString('ar')}</div>
                  </div>
                  {!n.is_read && <span className="badge badge-in">جديد</span>}
                </div>
              )) : (
                <div style={{textAlign:'center',padding:20,color:'var(--t3)',fontSize:11}}>
                  لا توجد إشعارات جديدة ✓
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
